import { Component, OnInit, ViewChild, Input, ChangeDetectionStrategy } from '@angular/core';
import { ModalController, AlertController, IonSearchbar, Platform } from '@ionic/angular/lazy';
import { APIService } from 'src/app/services/api.service';
import { AuthService } from 'src/app/services/auth.service';
import { Router } from '@angular/router';
import { Capacitor } from '@capacitor/core';

@Component({
    selector: 'app-affiliate-picker',
    templateUrl: './affiliate-picker.page.html',
    styleUrls: ['./affiliate-picker.page.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AffiliatePickerPage implements OnInit {

    @ViewChild('search_bar_input', { static: false }) search_bar_input: IonSearchbar;

    params = {};
    @Input() affiliate_id = null;
    affiliate = null;
	affiliates = null;
    visible_affiliates = null;
    query = null;
    modal_css_class = '';
    loading = false;

    constructor(
        private router: Router,
        private apiService: APIService,
        private authService: AuthService,
        public modalController: ModalController,
        public alertController: AlertController,
        private platform: Platform
    ) { }

    ngOnInit() {

        if(Capacitor.isNativePlatform()) {
            this.modal_css_class = 'fullscreen';
        }

        this.loadData().then(() => {}).catch(() => { });

    }

    loadData() {
        let promise = new Promise<void>((resolve, reject) => {
            this.loadAffiliates().then(() => {
                resolve();
            }).catch(() => {
                reject();
            });
        });
        return promise;
    }

    ionViewDidEnter() {
        // NOTE: we use a timeout here so the DOM gets a chance to load
        if(!this.affiliate) {
            setTimeout(() => {
                if(this.search_bar_input) {
                    this.search_bar_input.setFocus();
                }
            }, 200);
        }
    }

    loadAffiliates() {
        const promise = new Promise<void>((resolve, reject) => {
            this.authService.isLoggedIn().then(() => {
                this.loading = true;
                this.apiService.getAffiliates().then((affiliates) => {
                    if(affiliates) {
                        this.affiliates = affiliates;
                        for (let i = 0; i < this.affiliates.length; i++) {
                            if(this.affiliate_id == this.affiliates[i].id) {
                                this.affiliate = this.affiliates[i];
                            }
                        }
                    }
                    this.loading = false
                    resolve();
                })
                .catch((error) => {
                    if(error.status === 400) {
                        this.presentAlert("Unknown error", "Unfortunately something went wrong when trying to retrieve a list of affiliates.");
                    } 
                    else if(error.status === 403) {
                        this.presentAlert("Insufficient permissions", "You don't have permission to view affiliates.");
                    } 
                    else if(error.status == 404) {
                        this.presentAlert("Unavailable", "Unfortunately we're unable to retrieve a list of affiliates at this time.");
                    }
                    else if(error.status == 0) {
                        this.presentAlert("Connection failure", "Unable to reach the server. Please try again.");
                    }
                    this.loading = false
                    reject();
                });
            })
            .catch(() => {
                this.router.navigate(['switch-account'], { replaceUrl: true }).then(() => {
                    window.location.reload();
                });
            });
        });
        return promise;
    }

    searchAffiliates() {
        let query = this.query.toLowerCase().trim();
        this.visible_affiliates = null;
        if (query.length) {
            let affiliates = [];
            for (let i = 0; i < this.affiliates.length; i++) {
                if (this.affiliates[i].name.toLowerCase().includes(query)) {
                    affiliates.push(this.affiliates[i]);
                }
            }
            affiliates.sort((a, b) => {
                if (a['name'].toLowerCase() < b['name'].toLowerCase()) { return -1; }
                if (a['name'].toLowerCase() > b['name'].toLowerCase()) { return 1; }
                return 0;
            });
            this.visible_affiliates = affiliates;
        }
    }

    clear() {
        this.affiliate = null;
        setTimeout(() => {
            if(this.search_bar_input) {
                this.search_bar_input.setFocus();
            }
        }, 200);
    }

    close() {
        if(this.affiliate_id && !this.affiliate && !this.params["affiliate_id"]) {
            this.params["picker_action"] = "affiliate_deleted";
            this.modalController.dismiss(this.params);
        }
        else if(this.params["affiliate_id"]) {
            this.params["picker_action"] = "affiliate_selected";
            this.modalController.dismiss(this.params);
        }
        else {
            this.modalController.dismiss();
        }
    }

    select(affiliate_id) {
        for(let i = 0; i < this.affiliates.length; i++) {
            if(this.affiliates[i].id == affiliate_id) {
                this.params["affiliate_id"] = this.affiliates[i].id
                this.params["affiliate_name"] = this.affiliates[i].name
                break;
            }
        }
        this.close();
	}

	async presentAlert(header, message) {
		const alert = await this.alertController.create({
			header: header,
			message: message,
            cssClass:'alert',
			buttons: ["OK"],
		});
		await alert.present();
	}

}
